<template>
	<div class="allergens-chooser">
		<AppList :items="this.items">
			<template #link-slot="{item}">
				<div class="row centered flex-end text-slot">
					<AppTextInput :value="currentLinkInput" ref="link-input" :placeholder="getString('allergens_link_placeholder')" @changed-text="v => changedLink(v)" />
				</div>
			</template>
		</AppList>
	</div>
</template>

<script>
import {useLanguageStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import {validateLink} from "@/shared/helpers/strings";
import AppList from "@/shared/components/AppList.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		return {
			getString: languageStore.getString,
			userStore,
		};
	},
	name: "AllergensChooser",
	components: {
		AppTextInput,
		AppList,
	},
	data() {
		return {
			allergensType: 0,
			currentLinkInput: this.userStore.currBusiness.allergens_url ? this.userStore.currBusiness.allergens_url : '',
			activeLink: this.userStore.currBusiness && this.userStore.currBusiness.allergens_url !== null,
		}
	},
	computed: {
		items() {
			return [
				{title: this.getString("allergens_filter"), switch: true, explain: this.getString("allergens_filter_big_menu", [this.userStore.menuWord]), active: this.userStore.currBusiness && this.userStore.currBusiness.allergens_filter, callback: (active) => {this.userStore.currBusiness.allergens_filter = active;}},
				{title: this.getString("allergens_link"), switch: true, explain: this.getString("allergens_link_big_menu"), dropdownSlot: 'link-slot', active: this.activeLink, callback: this.switchedLink },
			]
		}
	},
	methods: {
		changedLink(v) {
			if(validateLink(v)) {
				this.userStore.currBusiness.allergens_url = v;
			}
			this.currentLinkInput = v;
		},
		switchedLink(active) {
			this.activeLink = active;
			if(active) {
				if(this.currentLinkInput.length > 0 && validateLink(this.currentLinkInput)) {
					this.userStore.currBusiness.allergens_url = this.currentLinkInput;
				}
			} else {
				this.userStore.currBusiness.allergens_url = null;
			}
		}
 	},
	watch: {
		"userStore.currBusinessId": {
			handler() {
				this.currentLinkInput = this.userStore.currBusiness.allergens_url ? this.userStore.currBusiness.allergens_url : '';
				this.activeLink = this.userStore.currBusiness && this.userStore.currBusiness.allergens_url !== null;
			},
			immediate: true,
		}
	}
}
</script>

<style lang="scss" scoped>
.allergens-chooser {

	.default-option {
		display: flex;
		justify-content: space-between;

		.text-explain {
			width: 30%;
			padding: 0 5px;
			text-align: left;
		}

		.text-content {
			width: 70%;
			padding: 0 5px;
			text-align: right;
			color: #9B9B9B;
			font-size: 12px;
		}

		@media (max-width: 600px) {
			flex-direction: column;
			align-items: center;

			.text-explain {
				width: 100%;
				text-align: center;
				margin-bottom: 10px;
			}

			.text-content {
				width: 100%;
				text-align: center;
			}

		}
	}

	.link-option {
		display: flex;
		justify-content: center;
		width: 100%;

		@media (max-width: 500px) {

			.input-wrapper {
				width: 100%;
			}
		}
	}

	.extra-text {
		width: 100%;
		p {
			font-size: 14px;
			line-height: 16px;
			color: #9B9B9B;
		}
		@media(max-width: 400px) {
			p {
				font-size: 12px;
			}
		}
	}
}
</style>